import gql from 'graphql-tag'

export default gql`
  {
    searchHeroInView @client
  }
`
